import { render, staticRenderFns } from "./RatingCheckView.vue?vue&type=template&id=231e89b2"
import script from "./RatingCheckView.vue?vue&type=script&lang=js"
export * from "./RatingCheckView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports